export default __webpack_public_path__ + "static/media/ViewDark.83166637.svg";